import { Helmet } from 'react-helmet';
import Lines from '../../components/common/Lines';
import ProgressScroll from '../../components/common/ProgressScroll';
import Cursor from '../../components/common/cusor';
import Header from '../../components/services/Header';
import Services from '../../components/services/Services';
import Navbar from '../../components/home-main/Navbar';
import Marquee from '../../components/home-main/Marquee';
import Footer from '../../components/home-main/Footer';



export default function LPageServices() {
  return (
    <>
      <Helmet>
        <title>GCAD</title>
        <link rel="icon" href="/light/assets/imgs/fox.png" />
        <link rel="shortcut icon" href="/light/assets/imgs/fox.png" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>


      <div>
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <Navbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header />
              <div className="padded-container">
                <Services />
                <div className='mb-60'>
                  <Marquee />
                </div>
              </div>
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}
